import IncorrectAnswers from './IncorrectAnswers';

export default IncorrectAnswers;
